/**
 * Free Samples code
 */

document.addEventListener("DOMContentLoaded", function() {
 // setTimeout(function(){
   if (window.innerWidth <= 1024) {  // Adjust the width as needed for your mobile breakpoint
        const newDiv = document.createElement('div');
       /* newDiv.innerHTML = `
            <div class="free-samples-cta free-samples-cta_div" style="display: flex;">  
                <p class="cart-sample-heading sdsdsds cus_item_count" data-count="1">Choose <span class="count_free" style="font-weight:600;">1</span> <strong>Free</strong> <span class="chnage_sample">Sample.</span> <span class="scroll-text"> Click &amp; scroll to add yours!</span></p>
                <a href="#" class="toggle-samples">Show Free Samples</a>
            </div>
        `;*/
          newDiv.innerHTML = document.querySelector('.free-samples-cta').outerHTML;
        const cartFooterWrapper = document.querySelector('.cart__footer-wrapper');
        if (cartFooterWrapper) {
            cartFooterWrapper.parentNode.insertBefore(newDiv, cartFooterWrapper);
        }
    }  
 // },1000);
 
    
 	// check if the cart page has been visited on the back button
	if(performance.navigation.type == 2){
		location.reload(true);
	}

 	// create an object to hold the samples "added" to the cart
    var samplesObj = {};
    var maxSamples = 2;

	// load in the latest product info from AWS
 
	/*fetch("//skinshop.ie/collections/samples/products.json?limit=250")
	.then(response => response.json())
	.then(json => drawProducts(json))
	.catch(function(err) {
		console.log('Fetch problem: ' + err.message);
	});*/
    fetch("//skinshop.ie/collections/samples/products.json?limit=250")
  .then(response => response.json())
  .then(json => {
    drawProducts(json);
    // After the first fetch is complete, initiate the second fetch
    return fetch('/cart.js');
  })
  .then(response => response.json())
  .then(cart => {
    //alert(cart.items);
    for (let i = 0; i < cart.items.length; i++) {
      let variantID = cart.items[i]['variant_id'];
      console.log(variantID);
      document.querySelectorAll(".add-sample-free").forEach(element => {
        console.log("element.getAttribute('data-variant-id')");
        let sampleId = element.getAttribute('data-variant-id');
        if (sampleId == variantID) {
          element.textContent = 'selected';
          element.style.backgroundColor = "#fff";
          element.style.pointerEvents = "none";
          element.style.color = "#3c3c3b";
          element.style.border = '1px solid #3c3c3b';
          element.removeAttribute("data-variant-id");
        }
      });
    }
  })
  .catch(function(err) {
    console.log('Fetch problem: ' + err.message);
  });
	// get a handle on the free samples container
	var samplesContainer = document.querySelector(".sample-products-wrapper");

	function drawProducts(products1){
   const products = products1.products;
  
	for(var i = 0; i < products.length; i++) {
			var product = products[i];
    
			var productTitle = product.title;
            if(product.images.length){
              var productImage = product.images[0].src;
            }else{
              var productImage = '';
            }
			
			var VariantId = product.variants[0].id;
           var vendorTitle = product.vendor;
			var availableStock = product.variants[0].available;
   

			if(availableStock > 0){
				var sampleDiv = `
                   <form method="post" class="sample-form" action="/cart/add">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${VariantId}" />
                    <input type="hidden" name="quantity" value="1"/>
					<div class="sample" data-vendor="${vendorTitle}">`;
                    if(productImage != ''){
					   sampleDiv +=	`<img src="${productImage}" alt="${productTitle}" />`;
                    }else{  
                       sampleDiv +=	`<svg class="placeholder--image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>`;
                    }
                    sampleDiv +=	`<h3>${productTitle}</h3>
						<p class="price">FREE</p>
                     <button type="submit" class="add-sample-free" data-variant-id="${VariantId}" data-product-title="${productTitle}">Select</button>
                     <!--- <a href="#" class="add-sample" data-variant-id="${VariantId}" data-product-title="${productTitle}">Select</a> --->
					</div></form><!-- end .sample -->
				`;

				samplesContainer.innerHTML += sampleDiv;
			}

		}

		// asign event lister to the 'select' buttons
 		const samplesWrapper = document.querySelector(".sample-products-wrapper");
		samplesWrapper.querySelectorAll(".add-sample-free").forEach(item => {
 			
 			item.addEventListener('click', function( e ) {
 
            samplesWrapper.classList.add('new-class');

 				//e.preventDefault();

 				var thisSampleTitle = e.target.dataset.productTitle;

 				var thisSampleVariantId = e.target.dataset.variantId;

 				if(Object.keys(samplesObj).length == maxSamples){
 					alert("You can only choose "+maxSamples+" free samples")
 				}else{
 					samplesObj[thisSampleVariantId] = { title: thisSampleTitle };
	            	updateSelection();
	        	}
 			
 			})

 		})


	}

	// assign event listener to the filter dropdown
	const filter = document.querySelector('#vendor-select');
  if(filter){
 	filter.addEventListener('change', filterHandler);
  }
 	function filterHandler( e ){

 		var vendorSelected = e.target.value;
		
		// hide all elements 		
 		document.querySelectorAll(".sample").forEach( item => { item.parentElement.classList.add("hide") });
   //   document.querySelectorAll(".sample").forEach( item => { item.classList.add("hide") });

 		if(vendorSelected == "View All"){
	 		document.querySelectorAll(".sample").forEach( item => { item.parentElement.classList.remove("hide") });
	 	}else{
	 		// now show just the elements with a data-attr that matches the selected vendor
	 		document.querySelectorAll("[data-vendor='"+vendorSelected+"']").forEach( item => { item.parentElement.classList.remove("hide") });
	 	}

 	}


 	const removeSample = document.querySelector('.sample-choices');
    if(removeSample){
    removeSample.addEventListener('click', removeSampleClickHandler);
}
    function removeSampleClickHandler(e) {
        
        if(e.target.matches('img.remove-sample')){

        	thisVariantId = e.target.dataset.variantId;

        	delete samplesObj[thisVariantId];
            updateSelection();
        }
    }


 	function updateSelection(){



        var buttonHTML = "";

        var sampleChoices = document.querySelector(".sample-choices");
        sampleChoices.innerHTML = "";

        // now build it
        for(sample in samplesObj){
        	
        	var thisVariantId = sample;
        	var thisTitle = samplesObj[sample].title;

        	// draw the buttons

//         	var buttonHTML = `
//         		<div class="choice">
// 					<img src="//cdn.shopify.com/s/files/1/0567/9867/5135/t/29/assets/icon-remove.png?v=6390300480128477031" alt="Remove" class="remove-sample" data-variant-id="${thisVariantId}"/>
// 					<span>${thisTitle}</span>
// 				</div><!-- end .choice -->
// 			`;

			sampleChoices.innerHTML += buttonHTML;

        }

        // var addButton = `
// <a href="#" class="add-samples-to-cart">Add To Cart</a>
//         `;

       // sampleChoices.innerHTML += addButton;

        
    }



        // slide reveal
        var container = document.querySelector('.cart-free-samples-container')
		var button = document.querySelector('.toggle-samples');

button.addEventListener('touchstart', toggleSamples);
button.addEventListener('click', toggleSamples);

function toggleSamples(e) {
    e.preventDefault();

    if (!container.classList.contains('show')) {
        container.classList.add('show');
        button.innerHTML = 'Hide Free Samples';
    } else {
        container.classList.remove('show');
        button.innerHTML = 'Show Free Samples';
    }
     const uniqueVendors = [...new Set(
        Array.from(document.querySelectorAll('.sample-form .sample[data-vendor]'))
            .map(el => el.dataset.vendor)
            .filter(Boolean)
    )];
    
    
    const vendorSelect = document.getElementById('vendor-select');
    if (vendorSelect) {
        Array.from(vendorSelect.options)
            .slice(1) 
            .forEach(option => {
                if (!uniqueVendors.includes(option.value)) {
                    option.remove();
                }
            });
    }
}


		// add samples to cart - delegated event here as the add button is created dynamically on each updateSelection() call
		
		function addSamplesHandler( e ){

			e.preventDefault();
			
			if(e.target.matches('a.add-samples-to-cart')){

				for(sample in samplesObj){
	                variantId = sample;
					CartJS.addItem(variantId, 1);
	            } 
	        }

		}

		const addSamplesButton = document.querySelector('.sample-choices');
        if(addSamplesButton){
    	addSamplesButton.addEventListener('click', addSamplesHandler);
        }
		 // Add an event handler that will trigger when all items are added.
		 $(document).on('cart.requestComplete', function() {
            location.reload(true);
		 	//window.location.href = '/cart/';
		 });

});

//alert('asdad');
 $(document).on("click",".add-sample-free",function(e) {
  // e.preventDefault();
   
   $('.add-sample-free').addClass('disabled');
    var varintID = $(this).attr('data-variant-id');
   $(this).css({"pointer-events": "none", "cursor": "default"});
   location.reload(true);
  // $('.sample-form').submit();

   //$(this).removeAttr("data-variant-id");
    // var data = {
    //   "id": varintID,
    //   "quantity": 1
    // }
    // $.ajax({
    //   type: 'POST',
    //   url: '/cart/add.js',
    //   data: data,
    //   dataType: 'json',
    //   success: function(data) { 
    //     setTimeout(function(){
    //     	window.location.href = '/cart/';
    //     },2500); 
    //   }
    // });
});

$(document).ready(function(){
 $('.free-samples-cta').css("display", "flex");
   var cusTotal = $('.cus_totalPrice').attr('data-orignal');
        var totalfree = $('.cart.page').attr('data-limit');
         $('.count_free').text(totalfree);
        var totalmins = totalfree -1;
        //$(".free-samples-cta_cus").css("display", "none");
         $(".free-samples-cta_cus").removeClass("intro");
      $('.cart_type_product').each(function(index){
          var checkpitem = index+1;
          if(checkpitem == totalfree){
            $('.free-samples-cta').css("display", "none");
            //$(".free-samples-cta_cus").css("display", "block");
             $(".free-samples-cta_cus").addClass("intro");
            $('.cart-free-samples-container').html(' ');
           }
          if(checkpitem > totalfree){
            const id2 = $(this).data('id');
            jQuery.post('/cart/update.js', {
              updates: {
                [id2]: 0
              }
            }).done(function(result){
              window.location.reload();
              $('.free-samples-cta').css("display", "block");
            });
          }else{
            // $('.free-samples-cta').css("display", "none");
          }
          if(totalfree == 2){
            if(checkpitem == 1){
              var tot = totalfree -1;
              $('.count_free').text(tot);
              $('.chnage_sample').text('Sample.');
            }

          }else{
   //  $('.chnage_sample').text('Samples.');
            if(checkpitem == 1){
              var tot = totalfree -1;
              $('.count_free').text(tot);
            }
            if(checkpitem == 2){
              var tot = totalfree -2;
              $('.count_free').text(tot);
            }
            if(checkpitem == 3){
              var tot = totalfree -3;
              $('.count_free').text(tot);
            }
            if(checkpitem == 4){
              var tot = totalfree -4;
              $('.count_free').text(tot);
            }
            if(checkpitem == 5){
              var tot = totalfree -5;
              $('.count_free').text(tot);
            }
            if(checkpitem == 6){
              var tot = totalfree -6;
              $('.count_free').text(tot);
            }
            if(checkpitem == 7){
              var tot = totalfree -7;
              $('.count_free').text(tot);
            }
            if(checkpitem == 8){
              var tot = totalfree -8;
              $('.count_free').text(tot);
            }
            if(checkpitem == 9){
              var tot = totalfree -9;
              $('.count_free').text(tot);
            }
            if(checkpitem == 10){
              var tot = totalfree -10;
              $('.count_free').text(tot);
            }
          }



        });

        // setTimeout(function() {
        //   var sss = $('.count_free').text();
        //   if(sss == 1){
        //     $('.chnage_sample').text('Sample.');
        //   }else{
        //    $('.chnage_sample').text('Sample(s).');  
        //   }
        // }, 3000);  
      /*  jQuery.getJSON('/cart.js', function(cart) {
          //console.log(cart.items);
          //alert(cart.items);
          for (var i = 0; i < cart.items.length; i++) {
            var variantID = cart.items[i]['variant_id'];
            $(".add-sample-free").each(function(){
              var sampleId = $(this).attr('data-variant-id');
              if(sampleId == variantID){
                $(this).text('selected');
                $(this).css("background-color", "#fff");
                $(this).css("pointer-events", "none");
                $(this).css("color", "#3c3c3b");
                $(this).css('border', '1px solid #3c3c3b');
                $(this).removeAttr("data-variant-id");
              }else{
              }
            });
          }
        });*/
       /*   fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
  
    //alert(cart.items);
    for (let i = 0; i < cart.items.length; i++) {
      let variantID = cart.items[i]['variant_id'];
     console.log(variantID)
      document.querySelectorAll(".add-sample-free").forEach(element => {
      console.log(element.getAttribute('data-variant-id'))
        let sampleId = element.getAttribute('data-variant-id');
        if (sampleId == variantID) {
          element.textContent = 'selected';
          element.style.backgroundColor = "#fff";
          element.style.pointerEvents = "none";
          element.style.color = "#3c3c3b";
          element.style.border = '1px solid #3c3c3b';
          element.removeAttribute("data-variant-id");
        }
      });
    }
  })
  .catch(error => console.error('Error:', error));*/
        $(document).on("click","a.toggle-samples",function() {

          jQuery.getJSON('/cart.js', function(cart) {
            //console.log(cart.items);
            for (var i = 0; i < cart.items.length; i++) {
              var variantID = cart.items[i]['variant_id'];
              $(".add-sample-free").each(function(){
                var sampleId = $(this).attr('data-variant-id');
                if(sampleId == variantID){
                  $(this).closest('form').find('input[name="id"]').val('');
                  $(this).text('selected');
                  $(this).css("background-color", "#fff");
                   $(this).css("pointer-events", "none");
                  $(this).css("color", "#3c3c3b");
                  $(this).css('border', '1px solid #3c3c3b');
                  $(this).removeAttr("data-variant-id");
                }
              });
            }
          });

        });    
 $('body').on('click', '.cart__form-item-quantity-wrapper button', function(){
    setTimeout(function() {
       window.location.reload();
    },2000);
 });
  
  $('.close-icon-sample').click(function(){
$('.cart-free-samples-container').removeClass('show');
  $('.toggle-samples').text('Show Free Samples');
});
});

